import * as Sentry from '@sentry/react'
import { BrowserRouter, useRoutes } from 'react-router-dom'

import { ScrollToTop } from 'src/app/core/routes/components/scroll-to-top'
import { routes } from 'src/app/core/routes/routes'

const AppRouter = () => {
  const element = useRoutes(routes)

  return element
}

const SentryAppRouter = Sentry.withSentryReactRouterV6Routing(AppRouter)

export const CoreRouter = () => (
  <BrowserRouter>
    <ScrollToTop />
    <SentryAppRouter />
  </BrowserRouter>
)
